import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import type { UserRole } from '@/store/authStore';
import UsersSection from '@/pages/admin/UsersSection';
import ProjectsSection from '@/pages/admin/ProjectsSection';

const ADMIN_ROLES: UserRole[] = ['tenant_admin', 'platform_admin'];
type AdminTab = 'users' | 'projects';

export default function AdminPage() {
  const { userRole } = useAuthStore();
  const navigate = useNavigate();
  const [tab, setTab] = useState<AdminTab>('users');

  useEffect(() => {
    if (userRole && !ADMIN_ROLES.includes(userRole)) {
      navigate('/home', { replace: true });
    }
  }, [userRole, navigate]);

  if (userRole && !ADMIN_ROLES.includes(userRole)) {
    return null;
  }

  return (
    <div className="mx-auto max-w-5xl space-y-6 p-6">
      <div className="flex items-baseline justify-between">
        <h1 className="text-2xl font-bold tracking-tight">Administration</h1>
      </div>

      <div className="border-b">
        <nav className="flex gap-1" aria-label="Admin tabs">
          <TabButton
            active={tab === 'users'}
            onClick={() => setTab('users')}
          >
            Users
          </TabButton>
          <TabButton
            active={tab === 'projects'}
            onClick={() => setTab('projects')}
          >
            Projects
          </TabButton>
        </nav>
      </div>

      {tab === 'users' ? <UsersSection /> : <ProjectsSection />}
    </div>
  );
}

function TabButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
        active
          ? 'border-mozaic-teal text-mozaic-teal'
          : 'border-transparent text-muted-foreground hover:text-foreground'
      }`}
    >
      {children}
    </button>
  );
}
